if ('NodeList' in window && !NodeList.prototype.forEach) {
	console.info('polyfill for IE11');
	NodeList.prototype.forEach = function (callback, thisArg) {
		thisArg = thisArg || window;
		for (let i = 0; i < this.length; i++) {
			callback.call(thisArg, this[i], i, this);
		}
	};
}

(function () {
	// JS SELECTs
	document.querySelectorAll('.js-select').forEach((select) => {
		const input = select.querySelector('input');
		const span = select.querySelector('span');
		const ops = select.querySelectorAll('li');

		input.addEventListener('reset', () => {
			input.value = ops[0].dataset.value;
			span.textContent = ops[0].textContent;
			select.classList.remove('active');
		});

		span.addEventListener('click', () => {
			select.classList.toggle('active');
		});

		ops.forEach((li) => {
			li.addEventListener('click', () => {
				input.value = li.dataset.value;
				span.textContent = li.textContent;
				select.classList.remove('active');
			});
		});
	});

	// TOGGLE LANG
	const langModule = document.querySelector('.js-toggleLang');
	if (langModule) {
		const langBtn = langModule.querySelector('.js-lang_btn');
		const langList = langModule.querySelector('.js-lang_list');
		langBtn.addEventListener('click', () => {
			langModule.classList.toggle('enabled');
		});
	}

	// TOGGLE TABLET NAV
	const tabletNav = document.querySelector('.js-tabletNav');
	if (tabletNav) {
		document.querySelectorAll('.js-toggleTabletNav').forEach((btn) => {
			btn.addEventListener('click', (e) => {
				tabletNav.classList.toggle('active');
				document.body.classList.toggle('noscroll', tabletNav.classList.contains('active'));
			});
		});
	}

	// TOGGLE MAIN NAV
	const mainNav = document.querySelector('.js-mainNav');
	if (mainNav) {
		document.querySelectorAll('.js-toggleMainNav').forEach((btn) => {
			btn.addEventListener('click', (e) => {
				mainNav.classList.toggle('active');
				document.body.classList.toggle('noscroll', mainNav.classList.contains('active'));
			});
		});
	}

	// LOGO BETWEEN PRIMARY NAV ITEMS
	insertLogoToNav();

	// Remove empty <p> tags created by tinymce
	const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach((e) => e.innerHTML.trim() === '' && e.parentNode.removeChild(e));

	// LBX CUSTOM MODAL
	const lbx_modal = new LBX('.js-lbx, .js-lightboxbtn');
	lbx_modal.customClass = 'lbx_modalContent';

	// LBX CUSTOM GALLERY
	const lbx_gallery = new LBX('.js-lbx_gallery');
	lbx_gallery.fullScreen = true;

	const customCloseIcon = document.getElementById('_fusion_icon-modalClose');
	const customArrowIcon = document.getElementById('_fusion_icon-modalArrow');

	if (customCloseIcon && customCloseIcon.innerHTML !== '') {
		lbx_modal.icons.close = customCloseIcon.innerHTML;
		lbx_gallery.icons.close = customCloseIcon.innerHTML;
	}
	if (customArrowIcon && customArrowIcon.innerHTML !== '') {
		lbx_gallery.icons.prev = customArrowIcon.innerHTML;
		lbx_gallery.icons.next = customArrowIcon.innerHTML;
		lbx_gallery.customClass = 'modal_oneArrow';
	}

	// GALLERY-FLEX FULLSCRREN MODE
	if (typeof customLightbox !== 'undefined') {
		customLightbox.fullScreen = true;
		// customLightbox.wideArrows = true;
	}

	// ADD text-block CLASSNAME TO TEXT MODULES
	document.querySelectorAll('.text-modules-wrapper').forEach((textModule) => textModule.classList.add('text-block'));

	//TRACKING
	const allLinks = document.querySelectorAll('a');
	allLinks.forEach(link =>{
		if(link.href.includes('mailto:'))link.classList.add('track-email');
		if(link.href.includes('tel:'))link.classList.add('track-phone');
		if(link.href.includes('https://www.google.com/maps'))link.classList.add('track-address');
		if(link.href.includes('https://resy.com/')||link.href.includes('https://www.opentable.com/'))link.classList.add('track-reservation');
		validationText(link);
	})
	function validationText(link){
		let arrayText = link.textContent.toLowerCase().split(' ');
		arrayText.forEach(text=>{
			if((text.includes('order') && text.includes('online')) || text.includes('order'))link.classList.add('track-order');
			if(text.includes('gift')||text.includes('card'))link.classList.add('track-gift');
		})
	}

})();

function insertLogoToNav() {
	if (!document.body.classList.contains('_gtpl_body-logoInNav')) {
		return false;
	}

	const totalLinks = document.querySelectorAll('.privary-navigation__item').length;
	const midLink = document.querySelector(`.privary-navigation__item:nth-child(${Math.floor(totalLinks / 2)})`);
	const navLogo = document.querySelector('._gtpl-header_nav-logo');

	if (midLink && navLogo) {
		midLink.insertAdjacentElement('afterend', navLogo);
	}
}
